module.exports = __webpack_public_path__ + "img/2_2-residenziale-villette-2.2d10ff75.png";